import { useEffect } from 'react'

export const useResetScrollToTop = () => useEffect(() => { window.scrollTo(0, 0) }, [])
